import { AttributeEditor } from './AttributeEditor';
import { ScopedSubscriptionListEditor } from './ScopedSubscriptionListEditor';
import { TagGroupEditor } from './TagGroupEditor';
/**
 * Airship contact.
 */
export class AirshipContact {
    constructor(plugin) {
        this.plugin = plugin;
    }
    /**
     * Identifies the contact with a named user Id.
     * @param namedUser The named user Id.
     * @returns A promise.
     */
    identify(namedUser) {
        return this.plugin.perform('contact#identify', namedUser);
    }
    /**
     * Resets the contact.
     * @returns A promise.
     */
    reset() {
        return this.plugin.perform('contact#reset');
    }
    /**
     * Gets the named user Id.
     * @returns A promise with the result.
     */
    getNamedUserId() {
        return this.plugin.perform('contact#getNamedUserId');
    }
    /**
     * Gets the contacts subscription lists.
     * @returns A promise with the result.
     */
    getSubscriptionLists() {
        return this.plugin.perform('contact#getSubscriptionLists');
    }
    /**
     * Edits tag groups.
     * @returns A tag group editor.
     */
    editTagGroups() {
        return new TagGroupEditor((operations) => {
            return this.plugin.perform('contact#editTagGroups', operations);
        });
    }
    /**
     * Edits attributes.
     * @returns An attribute editor.
     */
    editAttributes() {
        return new AttributeEditor((operations) => {
            return this.plugin.perform('contact#editAttributes', operations);
        });
    }
    /**
     * Edits subscription lists.
     * @returns A subscription list editor.
     */
    editSubscriptionLists() {
        return new ScopedSubscriptionListEditor((operations) => {
            return this.plugin.perform('contact#editSubscriptionLists', operations);
        });
    }
}
//# sourceMappingURL=AirshipContact.js.map